import React, { useState } from "react";
import { Send, Star } from "lucide-react";

export default function TestimonialForm() {
  const [form, setForm] = useState({
    nome: "",
    mensagem: "",
    estrelas: 5,
  });

  const enviar = () => {
    const texto = `
⭐ Novo Depoimento

Nome: ${form.nome}

Avaliação: ${form.estrelas} estrelas

Mensagem:
${form.mensagem}
`;

    window.open(
      `https://wa.me/5547998424643?text=${encodeURIComponent(texto)}`,
      "_blank"
    );
  };

  return (
    <section className="py-20">
      <div className="max-w-3xl mx-auto">

        <div className="rounded-[32px] bg-white/10 backdrop-blur-xl border border-white/15 p-8">

          <h2 className="font-heading text-4xl text-white mb-3">
            Conte como foi sua experiência 🐾
          </h2>

          <p className="text-white/70 mb-8">
            Seu depoimento ajuda outras famílias a conhecerem nosso trabalho.
          </p>

          <input
            placeholder="Seu nome"
            value={form.nome}
            onChange={(e)=>setForm({...form,nome:e.target.value})}
            className="w-full mb-5 rounded-xl bg-white/10 border border-white/20 p-4 text-white outline-none"
          />

          <textarea
            rows={5}
            placeholder="Escreva seu depoimento..."
            value={form.mensagem}
            onChange={(e)=>setForm({...form,mensagem:e.target.value})}
            className="w-full mb-5 rounded-xl bg-white/10 border border-white/20 p-4 text-white outline-none resize-none"
          />

          <div className="flex gap-2 mb-8">
            {[1,2,3,4,5].map((n)=>(
              <button
                key={n}
                onClick={()=>setForm({...form,estrelas:n})}
              >
                <Star
                  className={`w-7 h-7 ${
                    n<=form.estrelas
                      ? "fill-yellow-400 text-yellow-400"
                      : "text-white/40"
                  }`}
                />
              </button>
            ))}
          </div>

          <button
            onClick={enviar}
            className="flex items-center gap-2 rounded-full bg-gold text-royal px-8 py-4 font-semibold hover:scale-105 transition"
          >
            <Send className="w-5 h-5"/>
            Enviar depoimento
          </button>

        </div>
      </div>
    </section>
  );
}
